<template>
  <div>
    <v-tabs
      v-model="activeTab"
      class="playlist-tabs pl-2 my-6"
      align-tabs="start"
      fixed-tabs
      @change="saveActiveTab"
    >
      <v-tab>{{ $t('message.playlist.settings.tabs.general.name') }}</v-tab>
      <v-tab>{{ $t('message.playlist.settings.tabs.videos.name') }}</v-tab>
      <v-tab>{{ $t('message.playlist.settings.tabs.advanced.name') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <template>
          <slot name="general-tab" />
        </template>
      </v-tab-item>
      <v-tab-item>
        <template>
          <slot name="videos-tab" />
        </template>
      </v-tab-item>
      <v-tab-item>
        <template>
          <slot name="advanced-tab" />
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isInitialized: false,
      internalTab: null,
    }
  },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    activeTab: {
      get() {
        return this.internalTab ?? this.$route.query.tab ?? 0
      },
      set(val) {
        this.internalTab = val
      },
    },
  },
  methods: {
    saveActiveTab() {
      if (this.isInitialized) {
        localStorage.setItem('activeTab', this.activeTab)
      }
    },
    loadActiveTab() {
      const savedTab = localStorage.getItem('activeTab')
      this.activeTab = savedTab !== null ? parseInt(savedTab, 10) : 0
    },
  },
  mounted() {
    if (!this.$route.query.tab) {
      this.loadActiveTab()
    }
    this.isInitialized = true
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_typography';
.playlist-tabs {
  &::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }
    .v-slide-group__next {
      display: none !important;
    }
    .v-slide-group__content {
      flex: 1 1 auto !important;
    }
  }
  &.v-tabs {
    padding: 0;
    &::v-deep {
      .v-tabs-bar {
        height: unset;
        .v-tab {
          font-size: $font-size-small;
          height: 24px;
          text-transform: initial;
          letter-spacing: 0px;
          border-bottom: 2px solid transparent;
          padding-top: 0;
          padding-left: 3px;
          padding-right: 3px;
          padding-bottom: $spacing-03;
          min-width: auto;
          line-height: 150%;
          margin-right: $spacing-05;
          white-space: nowrap;
          justify-content: flex-start;
          max-width: fit-content;
          margin-left: 0 !important;

          &--active {
            color: varFigma(brand-50);
            border-bottom: 2px solid varFigma(brand-50);

            &:hover {
              color: varFigma(brand-40-dark);
            }
          }

          &:not([class*='active']) {
            color: var(--v-neutral-lighten1);

            &:hover {
              color: varFigma(neutral-30-base);
              border-bottom: 2px solid varFigma(neutral-80-lighter);
            }
          }
        }
        &.v-tabs-bar--is-mobile {
          .v-tab {
            font-size: 12px;
          }
        }
      }
      & .v-tab:hover::before,
      .v-tab::before {
        opacity: 0 !important;
      }
      & .v-tab:focus::before {
        opacity: 0 !important;
      }
    }

    &::v-deep {
      &.theme--dark {
        > .v-tabs-bar {
          .v-tab {
            &--active {
              color: var(--v-brand-lighten1);
            }
          }
        }
      }

      .v-tabs-slider-wrapper {
        display: none !important;
      }
    }
  }
}
</style>
